(function () {
    'use strict';

    function productDefinitionDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/admin/productDefinitions/';

        function loadProductDefinitions() {
            return $http.get(baseUrl).then(function (response) {
                return response.data;
            });
        };
        function loadProductDefinition(id) {
            return $http.get(baseUrl + id).then(function (response) {
                return response.data;
            }
            );
        };

        return {
            loadProductDefinitions: loadProductDefinitions,
            loadProductDefinition: loadProductDefinition
        }
    }

    productDefinitionDataService.$inject = ['$http'];

    angular.module('ecap.common').service('productDefinitionDataService', productDefinitionDataService);
})();
